// extracted by mini-css-extract-plugin
export var clarsyntPostTagDate = "post-tag-date-module--clarsynt-post-tag-date--2kiGO";